import { Button, Image } from "react-bootstrap";

import { Lightbox } from "components/Lightbox";

import { useAppSelector } from "store/hooks";
import { selectInvalidToken } from "store/slices/invalidToken";
import { selectSessionConflict } from "store/slices/sessionConflict";
import { getUserEmail } from "store/slices/user";

import { removeSessionFromStorage } from "utils/sessionStorageHandler";

// AIDEV-NOTE: Jediná cesta ven je znovunačtení — i křížek, Escape a klik mimo. Zavřený modal
// by nechal stránku s tréninkem, do kterého už nejde odpovídat; plné načtení zároveň vynuluje
// příznak konfliktu ve store. Uložená session (jedna na e-mail, sdílená záložkami) se maže jen
// u zavřeného tréninku — jinak by `Intro` studenta přesměroval zpátky do něj. U tréninku
// spuštěného jinde zůstává, `Intro` pak do běžícího tréninku přesměruje. [TD-461]
const SessionConflictModal = () => {
  const sessionConflict = useAppSelector(selectSessionConflict);
  const invalidToken = useAppSelector(selectInvalidToken);
  const userEmail = useAppSelector(getUserEmail);

  const reloadExercise = () => {
    if (sessionConflict === "notStarted") removeSessionFromStorage(userEmail);
    window.location.assign("/cviceni");
  };

  return (
    <Lightbox
      show={sessionConflict !== null && invalidToken === "idle"}
      onHide={reloadExercise}
      bodyTitleId="session-conflict-title"
    >
      <div className="d-flex justify-content-center">
        <Image src="/images/capy-question.svg" alt="" style={{ width: "140px" }} />
      </div>
      <div className="text-center mb-5">
        <h2 id="session-conflict-title" className="fs-18">
          Trénink se mezitím změnil
        </h2>
        <p>
          Trénink se spustil nebo skončil v jiném okně prohlížeče nebo na jiném zařízení, takže odpovědi z téhle stránky
          už nejde uložit.
        </p>
        <p className="fw-bold">Načti cvičení znovu a pokračuj tady.</p>
      </div>
      <Button className="w-100" onClick={reloadExercise}>
        Načíst cvičení znovu
      </Button>
    </Lightbox>
  );
};

export default SessionConflictModal;
